module.exports = __webpack_public_path__ + "media/images/p-mypageIdentificationTabBar/green_check-c782047a066c026e1a2842fcab769b12.svg";